import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { toast } from 'sonner'

// 後端錯誤回應的資料形狀
interface ApiErrorData {
  error?: {
    code?: string
    message?: string
  }
}

function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError<ApiErrorData>(error)) {
    return error.response?.data?.error?.message || fallback
  }
  return fallback
}

export interface CreateAnnouncementInput {
  title: string
  content: string
  target_type: 'clinic' | 'ad_supplier' | 'all'
  is_active?: boolean
  sort_order?: number
  provider_id?: number
}

export interface UpdateAnnouncementInput {
  title?: string
  content?: string
  target_type?: 'clinic' | 'ad_supplier' | 'all'
  is_active?: boolean
  sort_order?: number
}

export const announcementService = {
  create: async (data: CreateAnnouncementInput, token: string) => {
    try {
      const response = await apiClient.post('/api/announcements', data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      toast.success('公告建立成功')
      return response.data
    } catch (error) {
      toast.error(getApiErrorMessage(error, '建立公告失敗'))
      throw error
    }
  },

  update: async (id: number, data: UpdateAnnouncementInput, token: string) => {
    try {
      const response = await apiClient.put(`/api/announcements/${id}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      toast.success('公告更新成功')
      return response.data
    } catch (error) {
      toast.error(getApiErrorMessage(error, '更新公告失敗'))
      throw error
    }
  },

  delete: async (id: number, token: string) => {
    try {
      const response = await apiClient.delete(`/api/announcements/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      toast.success('公告已刪除')
      return response.data
    } catch (error) {
      toast.error(getApiErrorMessage(error, '刪除公告失敗'))
      throw error
    }
  },
}
